import { css, styled } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";

export const Wrapper = styled.div`
  background-color: var(--swatch3);
  color: var(--swatch2);
  padding: ${(props) => `${props.theme.spacing.m} 0 ${props.theme.spacing.l}`};

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${(props) =>
      `${props.theme.spacing.l} 0 ${props.theme.spacing.xl}`};
  }
`;

export const Title = styled.h1`
  margin: 0 0 ${(props) => props.theme.spacing.m};

  @media (min-width: ${mobileBreakPointCSS}) {
    margin-bottom: ${(props) => props.theme.spacing.l};
  }
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.m};

  > div {
    flex: 1;
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    flex-direction: row;
    gap: ${(props) => props.theme.spacing.l};

    > div:last-child {
      max-width: 400px;
    }
  }
`;

export const Card = styled.div<{ $transparentOnMobile?: boolean }>`
  border-radius: 10px;
  background-color: #fff;
  color: var(--swatch2);
  padding: ${(props) => props.theme.spacing.m};

  > h2 {
    margin: 0 0 ${(props) => props.theme.spacing.s};
  }

  ${(props) =>
    props.$transparentOnMobile &&
    css`
      background-color: transparent;

      @media (min-width: ${mobileBreakPointCSS}) {
        background-color: #fff;
      }
    `}
`;

export const CartItems = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.m};

  li {
    display: flex;
    gap: ${(props) => props.theme.spacing.xs};

    > div {
      flex: 1;
    }
  }

  h2 {
    margin: 0 0 ${(props) => props.theme.spacing.xs};
  }

  p {
    margin: 0;
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    gap: ${(props) => props.theme.spacing.l};

    li {
      gap: ${(props) => props.theme.spacing.m};
    }

    h2 {
      margin-bottom: ${(props) => props.theme.spacing.s};
    }
  }
`;

export const ProductImage = styled.img`
  display: block;
  width: 100px;
  height: 100px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 10px;

  @media (min-width: ${mobileBreakPointCSS}) {
    width: 230px;
    height: 230px;
  }
`;

export const CounterWrapper = styled.div`
  margin: ${(props) => `${props.theme.spacing.xs} 0`};

  @media (min-width: ${mobileBreakPointCSS}) {
    margin: ${(props) =>
      `${props.theme.spacing.s} 0 ${props.theme.spacing.xs}`};
  }
`;

export const DiscountCode = styled.form`
  margin-top: ${(props) => props.theme.spacing.l};
  margin-bottom: ${(props) => props.theme.spacing.m};

  label {
    display: block;
    margin-bottom: ${(props) => props.theme.spacing.s};
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: ${(props) => props.theme.spacing.xs};
  }

  button {
    margin-left: auto;
  }

  input {
    background-color: #fff;
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    > div {
      flex-direction: row;
      gap: ${(props) => props.theme.spacing.l};
    }

    button {
      margin-left: 0;
    }

    input {
      width: 190px;
    }
  }
`;

export const Table = styled.table`
  width: 100%;
  border-spacing: 0;

  td {
    padding-top: ${(props) => props.theme.spacing.s};
  }

  tbody tr:last-child td {
    padding-bottom: ${(props) => props.theme.spacing.s};
  }

  td:last-child {
    text-align: right;
  }

  tfoot td {
    border-top: 1px solid var(--swatch1);
    font-weight: 700;
  }
`;

export const ToCheckout = styled.div`
  text-align: center;
  margin-top: ${(props) => props.theme.spacing.m};

  a {
    width: 160px;
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    margin-top: ${(props) => props.theme.spacing.l};
    margin-bottom: ${(props) => props.theme.spacing.s};
  }
`;

export const Remove = styled.a`
  display: block;
  width: 24px;
  height: 24px;

  circle {
    fill: var(--swatch2);
  }
`;
